import { render, staticRenderFns } from "./mzfLogin.vue?vue&type=template&id=5dc86c4a&"
import script from "./mzfLogin.vue?vue&type=script&lang=js&"
export * from "./mzfLogin.vue?vue&type=script&lang=js&"
import style0 from "./mzfLogin.vue?vue&type=style&index=0&id=5dc86c4a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports